module.exports = __webpack_public_path__ + "img/location.b9146e47.png";